export default __webpack_public_path__ + "static/media/listac.eba47d8f.png";